import Checker from '../../img/checker.svg';
import { useHistory } from 'react-router-dom';
import { useAuth0 } from '../../util/react-auth0-wrapper';


const SurveyCard = ({ isDisabled, image, category, bgColor, text, list }) => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const history = useHistory();

  return (
    <div className="flex flex-col justify-center items-center space-y-28">
      <div
        className={`relative group card h-[650px] max-w-[400px] w-full ${
          isDisabled && category === 'extensive' ? 'bg-orange-300' : bgColor
        } ${isDisabled ? 'grayscale select-none' : ''}`}
        style={{
          backgroundColor: 'white',
          border: '3px solid rgb(0, 107, 0)',
          borderRadius: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          cursor: isDisabled ? 'default' : 'pointer',
        }}
        onClick={() => {
          if (!isDisabled) {
            history.push(`/app/surveys/${category}`);
          }
        }}
      >
        {/* Overlay alleen als gebruiker NIET is ingelogd */}
        {isDisabled && !isAuthenticated && (
          <>
            <div
              className="absolute top-0 left-0 w-full h-full z-20 bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-[20px] pointer-events-none"
            ></div>

            <div
              className="absolute top-0 left-0 w-full h-full z-30 flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-[20px] pointer-events-auto cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                loginWithRedirect();
              }}
            >
              <div
                className="text-black font-bold py-2 px-6 rounded text-center shadow"
                style={{
                  backgroundColor: '#f2c83c',
                  border: '1px solid black',
                }}
              >
                Log in om verder te gaan
              </div>
            </div>
          </>
        )}

        <img
          src={image}
          alt="timer"
          className={`${isDisabled ? 'opacity-60' : ''} w-[150px]`}
        />

        <button
          className="text-xl mt-2 font-medium py-2 px-4"
          style={{
            backgroundColor: '#f2c83c',
            border: '1px solid black',
            borderRadius: '5px',
            width: '80%',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (!isDisabled) {
              history.push(`/app/surveys/${category}`);
            }
          }}
        >
          {text}
        </button>

        <div
          className="card bg-transparent shadow-none rounded-2xl md:min-h-[350px] h-max w-full max-w-[350px] p-4 space-y-4"
          onClick={(e) => {
            e.stopPropagation();
            if (!isDisabled) {
              history.push(`/app/surveys/${category}`);
            }
          }}
        >
          {list?.map((item, _index) => (
            <div className="flex items-start space-x-2" key={_index}>
              <img src={Checker} alt="list checker" />
              <h4>{item}</h4>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SurveyCard;